import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="border-t border-border/50 py-12 mt-auto">
      <div className="container-custom max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-semibold" style={{ fontFamily: 'Playfair Display, serif' }}>
                <span className="text-gold">AgeForward</span> Society
              </span>
            </Link>
            <p className="text-muted-foreground text-sm">
              The premier networking platform for aging care professionals in New York City.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="overline text-gold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/events" className="text-muted-foreground hover:text-foreground transition-colors text-sm">
                  Browse Events
                </Link>
              </li>
              <li>
                <Link to="/membership" className="text-muted-foreground hover:text-foreground transition-colors text-sm">
                  Membership
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-muted-foreground hover:text-foreground transition-colors text-sm">
                  Join Community
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="overline text-gold mb-4">Contact</h4>
            <p className="text-muted-foreground text-sm">
              New York City, NY
            </p>
            <p className="text-muted-foreground text-sm mt-2">
              Advancing the future of aging care since 2024
            </p>
          </div>
        </div>

        <div className="border-t border-border/50 mt-10 pt-6 text-center">
          <p className="text-muted-foreground text-xs">
            © {new Date().getFullYear()} AgeForward Society. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
